import { Card, CardBody } from "@/components/ui";
import type { ReactNode } from "react";

interface AuthPageShellProps {
  title?: string;
  description?: string;
  children: ReactNode;
}

export function AuthPageShell({ title, description, children }: AuthPageShellProps) {
  const showHeading = Boolean(title || description);

  return (
    <div className="auth-page flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardBody className="px-6 py-8 sm:px-8">
          <div className="mb-8 flex justify-center">
            <img
              src="/brand-logo.png"
              alt="Brand Blvd"
              width={240}
              height={48}
              className="h-10 w-auto max-w-full"
            />
          </div>

          {showHeading ? (
            <div className="mb-6 space-y-1 text-center">
              {title ? (
                <h1 className="text-xl font-semibold tracking-tight text-[var(--color-text)]">
                  {title}
                </h1>
              ) : null}
              {description ? (
                <p className="text-sm text-[var(--color-text-muted)]">{description}</p>
              ) : null}
            </div>
          ) : null}

          {children}
        </CardBody>
      </Card>
    </div>
  );
}
